import { BaseDto } from './base.dto';

export class RecipeTypeDto extends BaseDto {
  name: string;
  code: string;
  isBulk: boolean;
  // is this complete??
}
